<template>
  <section class="ON_article_stream ON_120px_padding">
    <div class="container">
      <div class="ON_area_title_2">
        <h2>Trending News</h2>
        <p class="divider"></p>

        <!--experimental
<div class="row">
<div class="col-lg-2 col-sm-4 mt-sm-30 typo-sec">
        <v-select :options="options" :style="{'padding-left': '10px'}" v-model="filterCategories"></v-select>
</div>
<div class="col-lg-4 col-sm-6 mt-sm-30 typo-sec">
        <button
          @click="sortBy('category')"
          class="ON_generic_button danger circle more-bttn"
          :style="{ 'background-color': '#ff1857' }"
        >
          Sort by Category
          <span v-if="sort.field == 'category'"
            >({{ sort.desc ? "desc" : "asc" }})</span
          >
        </button>
        </div>
        </div>
experimental END-->

        <button
          @click="sortBy('category')"
          class="ON_generic_button danger circle more-bttn"
          :style="{ 'background-color': '#ff1857' }"
        >
          Sort by Category
          <span v-if="sort.field == 'category'"
            >({{ sort.desc ? "desc" : "asc" }})</span
          >
        </button>
        <button
          @click="sortBy('addition_time')"
          class="ON_generic_button danger circle more-bttn"
          :style="{ 'background-color': '#e5154e' }"
        >
          Sort by Time
          <span v-if="sort.field == 'addition_time'"
            >({{ sort.desc ? "desc" : "asc" }})</span
          >
        </button>
        <button
          @click="sortBy('title')"
          class="ON_generic_button danger circle more-bttn"
          :style="{ 'background-color': '#cc1345' }"
        >
          Sort by Title
          <span v-if="sort.field == 'title'"
            >({{ sort.desc ? "desc" : "asc" }})</span
          >
        </button>
        <button
          @click="sortBy('id')"
          class="ON_generic_button danger circle more-bttn"
          :style="{ 'background-color': '#b2103c' }"
        >
          Sort by Magic
          <span v-if="sort.field == 'id'"
            >({{ sort.desc ? "desc" : "asc" }})</span
          >
        </button>
      </div>
      <div class="row ON_article_stream_inner">
        <div
          class="col-lg-3 col-md-6"
          v-for="article in sortedData.slice(0, 4)"
          :key="article.id"
        >
          <div class="ON_article_item">
            <router-link
              :to="{
                name: 'trending',
                params: {
                  id: article.id
                }
              }"
              class="ON_cat_button"
              :style="{ background: '#330066' }"
              ><img
                class="img-custom"
                img
                v-bind:src="article.image"
                alt="../assets/slice.png"
                width="200"
                height="100"
            /></router-link>
            <div class="ON_article_card_text">
              <div class="date">
                <a
                  class="ON_cat_button"
                  href="#"
                  :style="{ background: '#330066' }"
                  >{{ article.category }}</a
                >
                <router-link
                  :to="{
                    name: 'trending',
                    params: {
                      id: article.id
                    }
                  }"
                  ><i class="fa fa-calendar" aria-hidden="true"></i
                  >{{ convertEpoch(article.addition_time) }}</router-link
                >
              </div>
              <router-link
                :to="{
                  name: 'trending',
                  params: {
                    id: article.id
                  }
                }"
                ><h4>
                  {{ article.title }}
                </h4></router-link
              >
              <p>
                {{ toolTipText(article.summary) }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="row ON_article_stream_inner">
        <div
          class="col-lg-3 col-md-6"
          v-for="article in sortedData.slice(4, 8)"
          :key="article.id"
        >
          <div class="ON_article_item">
            <router-link
              :to="{
                name: 'trending',
                params: {
                  id: article.id
                }
              }"
              class="ON_cat_button"
              :style="{ background: '#330066' }"
              ><img
                class="img-custom"
                img
                v-bind:src="article.image || imageLoadError"
                width="200"
                height="100"
            /></router-link>
            <div class="ON_article_card_text">
              <div class="date">
                <a
                  class="ON_cat_button"
                  href="#"
                  :style="{ background: '#330066' }"
                  >{{ article.category }}</a
                >
                <router-link
                  :to="{
                    name: 'trending',
                    params: {
                      id: article.id
                    }
                  }"
                  ><i class="fa fa-calendar" aria-hidden="true"></i
                  >{{ convertEpoch(article.addition_time) }}</router-link
                >
              </div>
              <router-link
                :to="{
                  name: 'trending',
                  params: {
                    id: article.id
                  }
                }"
                ><h4>
                  {{ article.title }}
                </h4></router-link
              >
              <p>
                {{ toolTipText(article.summary) }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </div>

    <div class="row" id="latest-news-ad">
      <div class="column"></div>
    </div>
  </section>
</template>

<script>
import db from "@/fb";
import { toolTipText } from "../toolTipText.js";
import { convertEpoch } from "../convertEpoch.js";

export default {
  mixins: [toolTipText, convertEpoch],
  computed: {
    sortedData() {
      if (!this.sort.field) {
        return this.trendingNews;
      }
      return this.trendingNews.concat().sort((a, b) => {
        if (this.sort.desc) {
          return a[this.sort.field] > b[this.sort.field] ? -1 : 1;
        } else {
          return a[this.sort.field] > b[this.sort.field] ? 1 : -1;
        }
      });
    },
    filterCategories(filterSelection) {
      if (filterSelection === "all") {
        return this.sortedData;
      }
      return this.sortedData.filter(item => {
        return item.category === filterSelection;
      });
    }
  },
  data() {
    return {
      trendingNews: [],
      options: [
        "all",
        "business",
        "entertainement",
        "politics",
        "sports",
        "tech"
      ],

      sort: {
        field: "",
        desc: true
      }
    };
  },
  methods: {
    sortBy(field) {
      if (field == this.sort.field) {
        this.sort.desc = !this.sort.desc;
      } else {
        this.sort.field = field;
        this.sort.desc = true;
      }
    },
    imageLoadError() {
      event.target.src = "../assets/slice.png";
    }
  },
  created() {
    db.collection("trending")
      .orderBy("addition_time", "desc")
      .limit(20)
      .onSnapshot(res => {
        const changes = res.docChanges();
        changes.forEach(change => {
          if (change.type === "added") {
            this.trendingNews.push({
              ...change.doc.data(),
              id: change.doc.id
            });
          }
        });
      });
  }
};
</script>
